import { Box, Stack, Typography } from '@mui/material';

import { ProjectStageEnum } from 'src/global/enums/project.enum';
import { colors } from 'src/global/styles/colors';

interface StageFilterProps {
  stages: Array<ProjectStageEnum>;
  selectedStage: ProjectStageEnum;
  setSelectedStage: (stage: ProjectStageEnum) => void;
}

export function StageFilter({ stages, selectedStage, setSelectedStage }: StageFilterProps) {
  return (
    <Stack direction={'row'} justifyContent={'space-between'} maxWidth={'800px'} spacing={2}>
      {stages.map((stage, index) => {
        const isActive = stage === selectedStage;
        const isNextActive = stage?.[index + 1] && stages[index + 1] === selectedStage;

        const selectedLine = isActive ? 'left-active-line' : isNextActive ? 'right-active-line' : 'none-active-line';
        return (
          <Stack key={stage} direction={'row'} alignItems={'start'} spacing={2} onClick={() => setSelectedStage(stage)}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}>
              {stage === selectedStage ? (
                <img src='/imgs/stages/active-stage.png' width={'32px'} height={'32px'} alt='active' />
              ) : (
                <Box
                  sx={{
                    cursor: 'pointer',
                  }}
                  margin={'7px !important'}
                  width={'18px'}
                  height={'18px'}
                  borderRadius={'50%'}
                  bgcolor={'#2D2D2D'}></Box>
              )}
              <Typography
                paddingTop={'12px'}
                variant={'h6'}
                fontSize={'14px'}
                lineHeight={'20px'}
                textAlign={'center'}
                sx={{
                  color: isActive ? colors.brand200 : colors.neutral90,
                  fontWeight: isActive ? 500 : 400,
                }}>
                {stage.charAt(0) + stage.slice(1).toLowerCase()}
              </Typography>
            </Box>
            {index !== stages.length - 1 && (
              <img
                src={`/imgs/stages/${selectedLine}.png`}
                className='cursor-pointer mt-4'
                width={'200px'}
                height={'3px'}
                alt={stage}
              />
            )}
          </Stack>
        );
      })}
    </Stack>
  );
}
